const BackIcon = () => (
    <svg width={30} height={30} fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="m13.375 23.375 1.75-1.75L9.75 16.25H25v-2.5H9.75l5.375-5.375-1.75-1.75L5 15l8.375 8.375Z"
            fill="#8C8594"
        />
    </svg>
)

export default BackIcon
